<ng-container [formGroup]="form">
  <mat-form-field class="full-width">
    <mat-select
      [placeholder]="'AUTOMATOR.objectScalarControl.type.placeholder' | translate"
      formControlName="valueType"
      required>
      @for (valueType of valueTypes; track trackByValueType($index, valueType)) {
        <mat-option [value]="valueType">
          {{ valueType }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  @if (form.get('stringValue')?.enabled) {
    <mat-form-field class="full-width">
      <input
        formControlName="stringValue"
        matInput
        type="text"
        [placeholder]="'AUTOMATOR.objectScalarControl.stringValue.placeholder' | translate">
    </mat-form-field>
  }
  @if (form.get('numberValue')?.enabled) {
    <mat-form-field class="full-width">
      <input
        formControlName="numberValue"
        matInput
        type="number"
        maxlength="18"
        appDigitsOnly
        [placeholder]="'AUTOMATOR.objectScalarControl.numberValue.placeholder' | translate"
        required>
      </mat-form-field>
  }
</ng-container>
